import { Component, OnInit, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import {
  FiltroDefinidoCampo,
  FiltroDefinidoSalvo,
  FiltrosDefinidosStorageService,
} from 'src/app/service/filtros-definidos-storage.service';
import { UtilService } from 'src/app/service/util.service';
import {
  criarCondicaoFiltroVazia,
  criarFiltroRegistrosPadrao,
  FiltroDefinidoCondicao,
  FiltroDefinidoRegistros,
  isCampoDataFiltro,
  obterOperadoresParaCampo,
  operadorExigeValor,
  OperadorFiltroOpcao,
} from 'src/app/utils/filtro-definido-condicoes.util';

interface CampoFiltroItem {
  key: string;
  label: string;
}

interface AbaFiltroItem {
  id: string;
  titulo: string;
  icone: string;
  campos: CampoFiltroItem[];
}

interface CampoSelecionadoItem extends CampoFiltroItem {
  abaId: string;
  abaTitulo: string;
}

/**
 * Chaves alinhadas aos `FormGroup` de `cadastro-cliente.component.ts`
 * (formCliente, formNaturalizacao, formJudIta, formAire, formFastIt, formTraducao, formBuscaItalia, formBuscaBrasil).
 */
@Component({
  selector: 'app-filtros-definidos',
  templateUrl: './filtros-definidos.component.html',
  styleUrls: ['./filtros-definidos.component.scss'],
})
export class FiltrosDefinidosComponent implements OnInit {
  tituloFiltro = '';
  termoBusca = '';

  abas: AbaFiltroItem[] = [
    {
      id: 'cadastro-cliente',
      titulo: 'Cadastro cliente',
      icone: 'fas fa-user',
      campos: [
        { key: 'sobrenome', label: 'Sobrenome' },
        { key: 'nome', label: 'Nome' },
        { key: 'cpf', label: 'CPF' },
        { key: 'email', label: 'Email/Login' },
        { key: 'senha', label: 'Senha de acesso plataforma' },
        { key: 'telefone_celular', label: 'Telefone celular' },
        { key: 'telefone_adicional', label: 'Telefone adicional' },
        { key: 'servicos', label: 'Serviços do cliente' },
        { key: 'rua', label: 'Logradouro' },
        { key: 'numero', label: 'Número' },
        { key: 'complemento', label: 'Complemento' },
        { key: 'bairro', label: 'Bairro' },
        { key: 'cep', label: 'CEP' },
        { key: 'pais', label: 'País' },
        { key: 'estado', label: 'Estado' },
        { key: 'cidade', label: 'Cidade' },
        { key: 'pasta_fisica', label: 'Pasta física' },
        { key: 'link_pasta', label: 'Link pasta virtual' },
        { key: 'apelido_pasta_virtual', label: 'Apelido pasta virtual' },
        { key: 'observacoes', label: 'Histórico' },
      ],
    },
    {
      id: 'naturalizacao',
      titulo: 'Naturalização',
      icone: 'fas fa-passport',
      campos: [
        { key: 'comuneTranscricao', label: 'Comune Transcrição' },
        { key: 'dadosTranscricao', label: 'Dados Transcrição' },
        { key: 'idStatusGeral', label: 'Status do Serviço' },
        { key: 'nomeConjugeItaliana', label: 'Nome cônjuge Italiano(a)' },
        { key: 'usuario', label: 'Usuário' },
        { key: 'senha', label: 'Senha' },
        { key: 'invioDigitale', label: 'Invio Digitale' },
        { key: 'accettazione', label: 'Accettazione' },
        { key: 'praticaK10', label: 'Prática K10' },
        { key: 'consegnaOriginali', label: 'Consegna Originali' },
        { key: 'notificaDecreto', label: 'Notifica Decreto' },
        { key: 'giuramento', label: 'Giuramento' },
      ],
    },
    {
      id: 'jud-ita',
      titulo: 'Cidadania',
      icone: 'fas fa-gavel',
      campos: [
        { key: 'modalidade', label: 'Modalidade' },
        { key: 'statusAdministrativo', label: 'Status' },
        { key: 'danteCausa', label: 'Dante Causa' },
        { key: 'comune', label: 'Comune' },
        { key: 'viaPaterna', label: 'Via Paterna' },
        { key: 'viaMaterna', label: 'Via Materna' },
        { key: 'ag', label: 'AG' },
        { key: 'agVfs', label: 'AG-VFS' },
        { key: 'dataAg', label: 'Data AG/AG-VFS' },
        { key: 'dataConvocacao', label: 'Convocação' },
        { key: 'dataEntregaConsulado', label: 'Entrega Consulado' },
        { key: 'remessaOnline', label: 'Remessa Online' },
        { key: 'remessaFisica', label: 'Remessa Física' },
        { key: 'ajuizamento', label: 'Ajuizamento' },
        { key: 'tribunal', label: 'Tribunal' },
        { key: 'nrg', label: 'NRG' },
        { key: 'audiencia', label: 'Audiência' },
        { key: 'sentenca', label: 'Sentença' },
        { key: 'richiesto', label: 'Richiesto' },
        { key: 'ritirato', label: 'Ritirato' },
        { key: 'invioDocAdemp', label: 'Invio DOC ADEMP' },
        { key: 'transcritasRecebidas', label: 'Transcritas recebidas' },
        { key: 'secaoApelo', label: 'Apelo' },
        { key: 'apeloNotificado', label: 'Apelo Notificado' },
        { key: 'primeiraAudiencia', label: '1º Audiência' },
        { key: 'apeloInscrito', label: 'Apelo Inscrito' },
        { key: 'segundaAudiencia', label: '2º Audiência' },
        { key: 'sentencaApelo', label: 'Sentença Apelo' },
      ],
    },
    {
      id: 'aire',
      titulo: 'AIRE',
      icone: 'fas fa-id-card',
      campos: [
        { key: 'servicoPago', label: 'Serviço Pago' },
        { key: 'consulado', label: 'Consulado' },
        { key: 'idStatusGeral', label: 'Status do Serviço' },
        { key: 'comune', label: 'Comune' },
        { key: 'usuario', label: 'Usuário' },
        { key: 'senha', label: 'Senha' },
        { key: 'inscricaoSolicitada', label: 'Inscrição Solicitada' },
        { key: 'inscricaoAprovada', label: 'Inscrição Aprovada' },
      ],
    },
    {
      id: 'fast-it',
      titulo: 'Fast-It',
      icone: 'fas fa-bolt',
      campos: [
        { key: 'servicoPago', label: 'Serviço Pago' },
        { key: 'consulado', label: 'Consulado' },
        { key: 'idStatusGeral', label: 'Status do Serviço' },
        { key: 'comune', label: 'Comune' },
        { key: 'usuario', label: 'Usuário' },
        { key: 'senha', label: 'Senha' },
      ],
    },
    {
      id: 'traducao',
      titulo: 'Tradução',
      icone: 'fas fa-language',
      campos: [
        { key: 'dataDemanda', label: 'Data da Demanda' },
        { key: 'prazoLimite', label: 'Prazo Limite' },
        { key: 'idStatusGeral', label: 'Status do Serviço' },
        { key: 'necessidadeDobradura', label: 'Necessidade de Dobradura' },
      ],
    },
    {
      id: 'busca-documentos-italia',
      titulo: 'Busca documentos — Itália',
      icone: 'fas fa-search',
      campos: [
        { key: 'dataDemanda', label: 'Data da Demanda' },
        { key: 'idStatusGeral', label: 'Status geral do pedido' },
      ],
    },
    {
      id: 'busca-documentos-brasil',
      titulo: 'Busca documentos — Brasil',
      icone: 'fas fa-flag',
      campos: [
        { key: 'dataDemanda', label: 'Data da Demanda' },
        { key: 'idStatusGeral', label: 'Status geral do pedido' },
      ],
    },
    {
      id: 'responsavel',
      titulo: 'Responsável',
      icone: 'fas fa-user-tie',
      campos: [
        { key: 'responsavel', label: 'Responsável' },
        { key: 'sigla', label: 'Sigla' },
        { key: 'data', label: 'Data' },
        { key: 'setar', label: 'Setar' },
      ],
    },
  ];

  abaAtivaId: string = this.abas[0].id;
  itensSelecionados: CampoSelecionadoItem[] = [];
  /** Filtro de registros (estilo SharePoint) sobre as colunas selecionadas. */
  filtroRegistros: FiltroDefinidoRegistros = criarFiltroRegistrosPadrao();
  filtrosSalvos: FiltroDefinidoSalvo[] = [];
  /** Quando preenchido, `Salvar` faz update do registro na API. */
  idFiltroEdicao: string | null = null;

  modalListaFiltrosRef: NgbModalRef | null = null;
  /** Busca dentro do modal de lista de filtros salvos. */
  termoBuscaListaSalvos = '';

  constructor(
    private readonly filtrosStorage: FiltrosDefinidosStorageService,
    private readonly util: UtilService,
    private readonly modalService: NgbModal,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    this.recarregarListaSalvos();
  }

  voltar(): void {
    this.router.navigate(['/home-gestao']);
  }

  private recarregarListaSalvos(): void {
    this.filtrosStorage.listar().subscribe({
      next: (lista) => {
        this.filtrosSalvos = [...lista].sort((a, b) => (a.criadoEm < b.criadoEm ? 1 : -1));
      },
      error: () => {
        this.filtrosSalvos = [];
      },
    });
  }

  get abaAtiva(): AbaFiltroItem {
    return this.abas.find((a) => a.id === this.abaAtivaId) || this.abas[0];
  }

  get camposAbaAtivaFiltrados(): CampoFiltroItem[] {
    const termo = this.termoBusca.trim().toLowerCase();
    if (!termo) {
      return this.abaAtiva.campos;
    }
    return this.abaAtiva.campos.filter((c) => c.label.toLowerCase().includes(termo));
  }

  get totalSelecionados(): number {
    return this.itensSelecionados.length;
  }

  get modoEdicao(): boolean {
    return !!this.idFiltroEdicao;
  }

  get filtroRegistrosAtivo(): boolean {
    return !this.filtroRegistros.mostrarTodos;
  }

  get podeConfigurarFiltroRegistros(): boolean {
    return this.itensSelecionados.length > 0;
  }

  obterQtdCondicoesFiltro(f: FiltroDefinidoSalvo): number {
    const fr = f?.filtroRegistros;
    if (!fr || fr.mostrarTodos) {
      return 0;
    }
    return (fr.condicoes || []).filter((c) => c.abaId && c.key && c.operador).length;
  }

  textoQtdCondicoesFiltro(f: FiltroDefinidoSalvo): string | null {
    const qtd = this.obterQtdCondicoesFiltro(f);
    if (qtd <= 0) {
      return null;
    }
    return qtd === 1 ? '1 condição' : `${qtd} condições`;
  }

  get filtrosSalvosFiltradosModal(): FiltroDefinidoSalvo[] {
    const t = this.termoBuscaListaSalvos.trim().toLowerCase();
    if (!t) {
      return this.filtrosSalvos;
    }
    return this.filtrosSalvos.filter((f) =>
      (f.titulo || '').toLowerCase().includes(t)
    );
  }

  abrirModalListaFiltros(content: TemplateRef<unknown>): void {
    this.termoBuscaListaSalvos = '';
    this.modalListaFiltrosRef = this.modalService.open(content, {
      size: 'lg',
      centered: true,
    });
    this.modalListaFiltrosRef.result.then(
      () => undefined,
      () => undefined
    ).then(() => {
      this.modalListaFiltrosRef = null;
    });
  }

  editarFiltroAPartirDoModal(f: FiltroDefinidoSalvo): void {
    this.iniciarEdicaoFiltro(f);
    this.modalListaFiltrosRef?.close('edit');
  }

  fecharModalListaFiltros(): void {
    this.modalListaFiltrosRef?.dismiss();
  }

  iniciarEdicaoFiltro(f: FiltroDefinidoSalvo, event?: Event): void {
    event?.preventDefault();
    event?.stopPropagation();
    this.idFiltroEdicao = f.id;
    this.tituloFiltro = f.titulo || '';
    this.itensSelecionados = (f.itens || []).map((item) => {
      const doCatalogo = this.obterCampo(item.abaId, item.key);
      if (doCatalogo) {
        return doCatalogo;
      }
      return {
        abaId: item.abaId,
        abaTitulo: item.abaTitulo || item.abaId,
        key: item.key,
        label: item.label || item.key,
      };
    });
    this.filtroRegistros = this.clonarFiltroRegistros(f.filtroRegistros);
    if (this.itensSelecionados.length > 0) {
      this.abaAtivaId = this.itensSelecionados[0].abaId;
    }
    this.termoBusca = '';
    this.sincronizarCondicoesComColunas();
  }

  cancelarEdicao(): void {
    this.idFiltroEdicao = null;
    this.tituloFiltro = '';
    this.itensSelecionados = [];
    this.filtroRegistros = criarFiltroRegistrosPadrao();
    this.termoBusca = '';
  }

  selecionarAba(abaId: string): void {
    this.abaAtivaId = abaId;
    this.termoBusca = '';
  }

  isCampoSelecionado(abaId: string, campoKey: string): boolean {
    return this.itensSelecionados.some((x) => x.abaId === abaId && x.key === campoKey);
  }

  toggleCampo(abaId: string, campoKey: string): void {
    const index = this.itensSelecionados.findIndex((x) => x.abaId === abaId && x.key === campoKey);
    if (index >= 0) {
      this.itensSelecionados.splice(index, 1);
      this.sincronizarCondicoesComColunas();
      return;
    }
    const campo = this.obterCampo(abaId, campoKey);
    if (!campo) {
      return;
    }
    this.itensSelecionados.push(campo);
    this.sincronizarCondicoesComColunas();
  }

  removerSelecionado(abaId: string, campoKey: string): void {
    const index = this.itensSelecionados.findIndex((x) => x.abaId === abaId && x.key === campoKey);
    if (index >= 0) {
      this.itensSelecionados.splice(index, 1);
      this.sincronizarCondicoesComColunas();
    }
  }

  moverSelecionadoParaCima(index: number): void {
    if (index <= 0 || index >= this.itensSelecionados.length) {
      return;
    }
    const atual = this.itensSelecionados[index];
    this.itensSelecionados[index] = this.itensSelecionados[index - 1];
    this.itensSelecionados[index - 1] = atual;
  }

  moverSelecionadoParaBaixo(index: number): void {
    if (index < 0 || index >= this.itensSelecionados.length - 1) {
      return;
    }
    const atual = this.itensSelecionados[index];
    this.itensSelecionados[index] = this.itensSelecionados[index + 1];
    this.itensSelecionados[index + 1] = atual;
  }

  limparSelecionados(): void {
    this.itensSelecionados = [];
    this.sincronizarCondicoesComColunas();
  }

  selecionarTodosDaAbaAtiva(): void {
    for (const campo of this.camposAbaAtivaFiltrados) {
      if (!this.isCampoSelecionado(this.abaAtiva.id, campo.key)) {
        const item = this.obterCampo(this.abaAtiva.id, campo.key);
        if (item) {
          this.itensSelecionados.push(item);
        }
      }
    }
  }

  limparAbaAtiva(): void {
    this.itensSelecionados = this.itensSelecionados.filter((x) => x.abaId !== this.abaAtiva.id);
    this.sincronizarCondicoesComColunas();
  }

  definirConectorCondicao(index: number, conector: 'e' | 'ou'): void {
    const condicoes = [...this.filtroRegistros.condicoes];
    const condicao = condicoes[index];
    if (!condicao) {
      return;
    }
    condicao.conector = conector;
    this.filtroRegistros = { ...this.filtroRegistros, condicoes };
  }

  definirModoFiltroRegistros(mostrarTodos: boolean): void {
    this.filtroRegistros = {
      ...this.filtroRegistros,
      mostrarTodos,
    };
    if (!mostrarTodos && this.filtroRegistros.condicoes.length === 0) {
      this.adicionarCondicaoFiltro();
    }
  }

  adicionarCondicaoFiltro(): void {
    const primeiraColuna = this.itensSelecionados[0];
    const condicao = criarCondicaoFiltroVazia();
    if (primeiraColuna) {
      condicao.abaId = primeiraColuna.abaId;
      condicao.key = primeiraColuna.key;
    }
    this.filtroRegistros = {
      ...this.filtroRegistros,
      condicoes: [...this.filtroRegistros.condicoes, condicao],
    };
  }

  removerCondicaoFiltro(index: number): void {
    const condicoes = [...this.filtroRegistros.condicoes];
    if (index < 0 || index >= condicoes.length) {
      return;
    }
    condicoes.splice(index, 1);
    this.filtroRegistros = {
      ...this.filtroRegistros,
      condicoes,
    };
  }

  aoAlterarColunaCondicao(index: number, campoRef: string): void {
    const condicoes = [...this.filtroRegistros.condicoes];
    const condicao = condicoes[index];
    if (!condicao) {
      return;
    }
    const [abaId, key] = campoRef.split(':');
    condicao.abaId = abaId || '';
    condicao.key = key || '';
    const operadores = obterOperadoresParaCampo(condicao.key);
    if (!operadores.some((o) => o.id === condicao.operador)) {
      condicao.operador = operadores[0].id;
    }
    this.filtroRegistros = { ...this.filtroRegistros, condicoes };
  }

  obterRefCampoSelecionado(item: CampoSelecionadoItem): string {
    if (!item.abaId || !item.key) {
      return '';
    }
    return `${item.abaId}:${item.key}`;
  }

  obterOperadoresCondicao(condicao: FiltroDefinidoCondicao): OperadorFiltroOpcao[] {
    return obterOperadoresParaCampo(condicao.key);
  }

  operadorCondicaoExigeValor(condicao: FiltroDefinidoCondicao): boolean {
    return operadorExigeValor(condicao.operador);
  }

  isCampoDataCondicao(condicao: FiltroDefinidoCondicao): boolean {
    return isCampoDataFiltro(condicao.key);
  }

  trackByCondicaoIndex(index: number): number {
    return index;
  }

  salvarFiltro(): void {
    const titulo = (this.tituloFiltro || '').trim();
    if (!titulo) {
      this.util.toasterShowWarning('Atenção', 'Informe um título para o filtro.');
      return;
    }
    if (this.itensSelecionados.length === 0) {
      this.util.toasterShowWarning('Atenção', 'Selecione ao menos um campo.');
      return;
    }
    if (!this.validarFiltroRegistros()) {
      return;
    }
    const itens: FiltroDefinidoCampo[] = this.itensSelecionados.map((x) => ({
      abaId: x.abaId,
      abaTitulo: x.abaTitulo,
      key: x.key,
      label: x.label,
    }));
    const eraNovo = !this.idFiltroEdicao;
    this.util.showLoading();
    this.filtrosStorage
      .salvar({
        titulo,
        itens,
        filtroRegistros: this.clonarFiltroRegistros(this.filtroRegistros),
        id: this.idFiltroEdicao || undefined,
      })
      .subscribe({
      next: () => {
        this.util.closeLoading();
        this.recarregarListaSalvos();
        if (eraNovo) {
          this.tituloFiltro = '';
          this.itensSelecionados = [];
          this.filtroRegistros = criarFiltroRegistrosPadrao();
          this.idFiltroEdicao = null;
        }
        this.util.toasterShowSuccess(
          'Sucesso',
          eraNovo
            ? 'Filtro salvo no servidor. Você pode escolhê-lo na tela inicial (gestão).'
            : 'Filtro atualizado.'
        );
      },
      error: (err: Error) => {
        this.util.closeLoading();
        this.util.toasterShowError('Erro', err?.message || 'Não foi possível salvar o filtro.');
      },
    });
  }

  excluirFiltroSalvo(id: string, event?: Event): void {
    event?.stopPropagation();
    if (this.idFiltroEdicao === id) {
      this.cancelarEdicao();
    }
    this.util.showLoading();
    this.filtrosStorage.excluir(id).subscribe({
      next: () => {
        this.util.closeLoading();
        this.recarregarListaSalvos();
        this.util.toasterShowSuccess('Sucesso', 'Filtro removido.');
      },
      error: (err: Error) => {
        this.util.closeLoading();
        this.util.toasterShowError('Erro', err?.message || 'Não foi possível excluir o filtro.');
      },
    });
  }

  private validarFiltroRegistros(): boolean {
    if (this.filtroRegistros.mostrarTodos) {
      return true;
    }
    const condicoes = this.filtroRegistros.condicoes || [];
    if (condicoes.length === 0) {
      this.util.toasterShowWarning(
        'Atenção',
        'Adicione ao menos uma condição de filtro ou escolha «Mostrar todos os registros».'
      );
      return false;
    }
    for (let i = 0; i < condicoes.length; i++) {
      const c = condicoes[i];
      if (!c.abaId || !c.key) {
        this.util.toasterShowWarning('Atenção', `Selecione a coluna na condição ${i + 1}.`);
        return false;
      }
      if (operadorExigeValor(c.operador) && !(c.valor || '').trim()) {
        this.util.toasterShowWarning('Atenção', `Informe o valor na condição ${i + 1}.`);
        return false;
      }
    }
    return true;
  }

  private sincronizarCondicoesComColunas(): void {
    if (this.itensSelecionados.length === 0) {
      this.filtroRegistros = criarFiltroRegistrosPadrao();
      return;
    }
    const refsValidas = new Set(
      this.itensSelecionados.map((i) => this.obterRefCampoSelecionado(i))
    );
    const condicoes = (this.filtroRegistros.condicoes || []).filter((c) =>
      refsValidas.has(`${c.abaId}:${c.key}`)
    );
    if (!this.filtroRegistros.mostrarTodos && condicoes.length === 0) {
      const condicao = criarCondicaoFiltroVazia();
      const primeira = this.itensSelecionados[0];
      condicao.abaId = primeira.abaId;
      condicao.key = primeira.key;
      condicoes.push(condicao);
    }
    this.filtroRegistros = {
      ...this.filtroRegistros,
      condicoes,
    };
  }

  private clonarFiltroRegistros(origem?: FiltroDefinidoRegistros): FiltroDefinidoRegistros {
    const base = origem ?? criarFiltroRegistrosPadrao();
    return {
      mostrarTodos: !!base.mostrarTodos,
      condicoes: (base.condicoes || []).map((c) => ({
        abaId: c.abaId,
        key: c.key,
        operador: c.operador,
        valor: c.valor,
        conector: c.conector === 'ou' ? 'ou' : 'e',
      })),
    };
  }

  private obterCampo(abaId: string, campoKey: string): CampoSelecionadoItem | null {
    const aba = this.abas.find((a) => a.id === abaId);
    if (!aba) {
      return null;
    }
    const campo = aba.campos.find((c) => c.key === campoKey);
    if (!campo) {
      return null;
    }
    return {
      abaId: aba.id,
      abaTitulo: aba.titulo,
      key: campo.key,
      label: campo.label,
    };
  }
}
